import { getStripeSubscriptionPurchasePreview, } from 'features/premium/actions/stripe';
import { muteErrorAndResult, useFetchOld } from 'hooks';
import { useCallback } from 'react';
import { useAppSelector } from 'store/hooks';
const useProRataAmount = () => {
    const emmaProStatus = useAppSelector((state) => state.user.user.emmaProStatus);
    const [, , isFetchingStripePreview, fetch] = useFetchOld(muteErrorAndResult);
    const getPreview = useCallback(async (priceId, discount) => {
        const isSubscriptionChange = emmaProStatus?.active && emmaProStatus.store === 'stripe';
        const prorationDate = isSubscriptionChange
            ? new Date().toISOString()
            : undefined;
        return fetch(getStripeSubscriptionPurchasePreview({
            priceId,
            prorationDate,
            isSubscriptionChange,
            couponId: discount?.discount?.couponId,
        }));
    }, [emmaProStatus?.active, emmaProStatus.store]);
    return { getPreview, isFetchingStripePreview };
};
export default useProRataAmount;
